import { takeEvery, put, all } from 'redux-saga/effects';
import apiFetcher from '../../tools/api-fetcher';

import * as types from '../../actions/candidate/candidate-more-vacancies/types';
import * as actions from '../../actions/candidate/candidate-more-vacancies';

import queryStringify from '../../tools/query-stringify';
import handleError from '../../tools/error-helper';

function* getVacancies({ queryParams }) {
  yield put(actions.setMoreVacanciesListLoading(true));
  try {
    const { data } = yield apiFetcher.auth().get(`candidates/current/schools/vacancies?${queryStringify({...queryParams})}`);
    yield put(actions.setMoreVacanciesList(data));
  } catch (exception) {
    yield handleError(exception);
  }

  yield put(actions.setMoreVacanciesListLoading(false));
}

export default function* moreVacanciesSaga() {
  yield all([
    takeEvery(types.CANDIDATE_MORE_VACANCIES_GET_LIST, getVacancies)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/candidate/candidate-more-vacancies.js